import ReactDOM from 'react-dom/client';
import App from './components/App';

const el = document.querySelector('#feature');
const lightboxWrapper = document.createElement('div');
lightboxWrapper.setAttribute('id', 'lightbox-wrapper');
const mainContent = document.querySelector('body');
mainContent.appendChild(lightboxWrapper);

if (el) {
	const root = ReactDOM.createRoot(el);

	const { default_view, hide_all_features_button, custom_title, custom_description } = JSON.parse(el.getAttribute('data-custom-data'));

	root.render(
		<App
			customDescription={custom_description}
			customTitle={custom_title}
			hideAllFeaturesButton={hide_all_features_button}
			restUrl={el.getAttribute('data-rest-url')}
			view={default_view}
		/>,
	);
}
